import { AUTH_PREFIX_PATH } from "configs/AppConfig";

const { Route, Redirect, useLocation } = require("react-router-dom");

export default function RouteInterceptor({ children, isAuthenticated, ...rest }) {
  
  const {search} = useLocation()
  const searchParams = new URLSearchParams(search);
  const companyKey = searchParams.get("key");
  
  return (
    <Route
      {...rest}
      render={({ location }) =>
        (isAuthenticated || companyKey) ? (
          children
        ) : (
          <Redirect
            to={{
              pathname: AUTH_PREFIX_PATH,
              state: { from: location }
            }}
          />
        )
      }
    />
  );
}